<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix container-top">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item to="/sys/organizational"
            >权限配置</el-breadcrumb-item
          >
          <el-breadcrumb-item>特殊权限配置</el-breadcrumb-item>
        </el-breadcrumb>
        <el-button size="mini" type="primary" @click="inheritanceUserInfo"
          >继承权限</el-button
        >
      </div>
      <el-descriptions>
        <el-descriptions-item label="用户名称">{{
          itemInfo.realName
        }}</el-descriptions-item>
        <el-descriptions-item label="联系方式">{{
          itemInfo.userMobile
        }}</el-descriptions-item>
        <el-descriptions-item label="性别">
          <span v-if="itemInfo.userSex == 1">男</span>
          <span v-if="itemInfo.userSex == 0">女</span>
        </el-descriptions-item>
        <el-descriptions-item label="邮箱">{{
          itemInfo.userEmail
        }}</el-descriptions-item>
        <!-- <el-descriptions-item label="系统" v-if="itemInfo.companyList.length > 0">{{ itemInfo.companyList[0].companyName }}</el-descriptions-item> -->
        <el-descriptions-item label="部门">{{
          itemInfo.groupName
        }}</el-descriptions-item>
        <el-descriptions-item label="岗位">{{
          itemInfo.positionNam
        }}</el-descriptions-item>
        <el-descriptions-item label="用户状态">
          <el-tag size="small" type="success" v-if="itemInfo.userStatus == 0"
            >开启</el-tag
          >
          <el-tag size="small" type="danger" v-if="itemInfo.userStatus == 1"
            >关闭</el-tag
          >
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
    <el-card class="box-card" style="margin-top: 10px">
      <el-row :gutter="24">
        <el-col :span="5">
          <h6 style="height: 40px">系统</h6>
          <el-tree
            ref="tree"
            :data="systemList"
            highlight-current
            accordion
            show-checkbox
            check-strictly
            node-key="companyId"
            @check="checkChange"
            :props="companyProps"
          >
            <div
              class="custom-tree-node"
              slot-scope="{ node, data }"
              @mouseenter="mouseenter(data)"
              @mouseleave="mouseleave(data)"
              style="vertical-align: middle"
            >
              <span style="font-size: 14px">{{ node.label }}</span>
              <span style="margin-right: 10px; color: red">
                <el-link
                  v-show="data.del"
                  size="small"
                  type="info"
                  @click.stop.prevent="() => deleteInfo(data)"
                  style="float: right"
                  icon="el-icon-delete-solid"
                ></el-link>
              </span>
            </div>
          </el-tree>
        </el-col>
        <el-col :span="5">
          <h6 style="height: 40px">菜单</h6>
          <el-tree
            ref="menuTree"
            :data="buttonList"
            highlight-current
            accordion
            show-checkbox
            node-key="menuId"
            :default-expanded-keys="treeExpandMenuData"
            @check="checkButtonChange"
            :props="buttonProps"
          >
          </el-tree>
        </el-col>
        <el-col :span="5">
          <h6 style="height: 40px">部门</h6>
          <el-radio-group
            ref="radio"
            v-model="
              requestParams.defineAccessItemConfigurationDTOList.dataStatus
            "
            style="padding-bottom: 10px"
          >
            <el-radio :label="1">全部权限</el-radio>
            <el-radio :label="0">部分权限</el-radio>
            <el-radio :label="-1">仅自己</el-radio>
          </el-radio-group>
          <el-tree
            ref="tree3"
            :data="groupList"
            highlight-current
            accordion
            show-checkbox
            node-key="groupId"
            :default-expanded-keys="treeExpandData"
            :default-checked-keys="
              requestParams.defineAccessItemConfigurationDTOList.groupId
            "
            @check="checkGroupChange"
            :props="groupProps"
          >
          </el-tree>
        </el-col>
        <el-col
          :span="9"
          v-if="
            requestParams.defineAccessItemConfigurationDTOList.dataStatus == 0
          "
        >
          <h6 style="height: 40px">用户选择</h6>
          <el-transfer
            v-model="selectUserList"
            :titles="['未选择', '已选择']"
            :props="{ key: 'userId', label: 'realName' }"
            :data="userList"
            @change="checkChangeUser"
          >
          </el-transfer>
        </el-col>
      </el-row>
      <div class="footer-btn">
        <div class="footer-btn">
          <el-button size="small" type="danger" @click="toBack()"
            >关 闭</el-button
          >
          <el-button size="small" type="success" @click="confirmConfig"
            >确 定</el-button
          >
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getUserInfoForCompanyId } from "@/api/usermange";
import { getDepartInfoList } from "@/api/departMange";
import {
  findMenuInfo,
  findSystemInfo,
  findMenuList,
  inheritPermission,
  findPageUserInfo,
  defineAccessConfig,
  getAllSystemList,
  getSystemAllMenu,
  cancelSpecialUserInfo,
} from "@/api/organizeMange";
import { unique } from "@/utils";

export default {
  name: "CustomPermission",
  data() {
    return {
      dialogVisible: false,
      itemInfo: {}, // 用户信息
      systemList: [], // 所有系统列表
      companyIds: null, // 选择的系统ID
      menuList: [], // 某一系统下用户所拥有的菜单列表
      selectMenuId: "", // 所选择的菜单ID
      buttonList: [], // 某一菜单下的按钮列表
      groupList: [], // 主组织信息
      treeExpandMenuData: [], // 默认展开的菜单节点
      treeExpandData: [], // 默认展开的部门节点
      selectButtonId: "", // 所选择按钮ID
      value: [], // 穿梭框双向绑定的值
      userList: [], // 所有用户列表
      selectUserList: [], // 已选择的用户列表
      groupId: [], // 选择的主组织项
      arr: [], // 已选择的系统列表
      dataStatus: null,
      companyProps: {
        children: "children",
        label: "companyName",
      },
      buttonProps: {
        children: "children",
        label: "menuName",
      },
      groupProps: {
        children: "children",
        label: "groupName",
      },
      // 用户之前存在的信息
      groupParams: {
        companyId: -1,
        defaultPositionName: null,
        groupIds: [],
        pageNo: 1,
        pageSize: 1000,
        userCode: 1,
        userId: null,
        realName: null,
        userStatus: -1,
      },
      // 分配的用户信息
      requestParams: {
        companyId: null,
        defineAccessItemConfigurationDTOList: {
          dataStatus: "",
          groupId: [],
          userCode: [],
        },
        menuIds: [],
        userId: null,
      },
      selectMenuList: [], // 选择的菜单列表
      selectSystem: [], // 选择的系统
    };
  },
  watch: {
    companyIds(newVal, oldVal) {
      if (newVal) {
        this.getAllMenuList();
        this.getDepartList();
      }
    },
    "groupParams.groupIds"(newVal, oldVal) {
      if (newVal) {
        this.getUserList();
      }
    },
    "requestParams.defineAccessItemConfigurationDTOList.dataStatus"(newVal) {
      if (newVal == 1) {
        this.requestParams.defineAccessItemConfigurationDTOList.userCode = [];
      }
    },
    "requestParams.defineAccessItemConfigurationDTOList.groupId"(newVal) {
      if (newVal.length > 0) {
        this.groupParams.groupList = newVal;
        this.getUserList();
      }
    },
  },
  async created() {
    await this.getUserDataInfo();
    await this.getAllSystemListInfo();
  },

  methods: {
    // 根据用户ID查询用户信息
    async getUserDataInfo() {
      const res = await getUserInfoForCompanyId(this.$route.query.id);
      if (res.code === "200") {
        this.itemInfo = res.data;
        this.unRoleList = res.data.roleArray;
      } else {
        this.$message.error(res.msg);
      }
    },
    // 查询所有系统
    async getAllSystemListInfo() {
      if (!this.$route.query.id) {
        return;
      }
      const res = await getAllSystemList(this.$route.query.id);
      if (res.code == 200) {
        const arr = [];
        res.data.forEach((item) => {
          if (item.checkAuth) {
            arr.push(item.companyId);
          }
        });
        this.systemList = res.data;
        arr.length > 0 ? (this.companyIds = arr[0]) : (this.companyIds = res.data[0].companyId);
        this.$refs.tree.setCheckedKeys(arr);
      } else {
        this.$message.error(res.msg);
      }
    },
    // 根据用户选择的系统查询该系统下选择的菜单及按钮
    async getAllMenuList() {
      let params = {
        companyId: this.companyIds,
        userId: this.itemInfo.userId,
      };
      const res = await getSystemAllMenu(params);
      if (res.code == 200) {
        this.buttonList = res.data.menuDTOList;
        this.$nextTick(() => {
          res.data.menuEntityList.forEach(item => {
            const node = this.$refs.menuTree.getNode(item)
            if(node.isLeaf) {
              this.$refs.menuTree.setChecked(node, true);
            }
          })
        })
      } else {
        this.$message.error(res.msg);
      }
    },
    // 查询部门组织
    async getDepartList() {
      let params = {
        userCode: 1,
        companyId: this.companyIds,
        userId: this.$route.query.id,
      };
      const res = await getDepartInfoList(params);
      if (res.code === "200") {
        this.groupList = res.data;
        let provincialCenterId = res.data[0].groupId; //默认展开第一个节点
        this.treeExpandData.push(provincialCenterId);
        res.data.forEach((item) => {
          this.setGroupId(item);
        });
        this.requestParams.defineAccessItemConfigurationDTOList.dataStatus =
          res.data[0].dataStatus;
      } else {
        this.$message.error(res.msg);
      }
    },
    // 递归
    setGroupId(obj) {
      // 1. 判断是不是对象，对象里面是否有children 没有return
      if (typeof obj !== "object" || obj === null || !obj.children) {
        return;
      }
      // 2. 循环children [] 验证是否checkStatus, 执行方法s
      const arr = [];
      obj.children.forEach((item) => {
        if (item.checkStatus) {
          arr.push(item.groupId);
        }
        this.setGroupId(item);
      });
      this.requestParams.defineAccessItemConfigurationDTOList.groupId = this.requestParams.defineAccessItemConfigurationDTOList.groupId.concat(
        arr
      );
      // console.log(this.requestParams.defineAccessItemConfigurationDTOList.groupId)
      this.$refs.tree3.setCheckedKeys(arr);
    },
    // 根据用户ID查询所拥有的系统
    async getAllSystemInfo() {
      let params = {
        roleName: "",
        userCode: this.$route.query.id,
      };
      const res = await findSystemInfo(params);
      if (res.code === "200") {
        res.data.forEach((item) => {
          if (item.checkAuth) {
            this.selectSystem.push(item.companyId);
          }
        });
      } else {
        this.$message.error(res.msg);
      }
    },
    // 选择的系统
    checkChange(data, checked, node) {
      const arr = [];
      this.companyIds = data.companyId;
      if (checked && arr.indexOf(data.companyId) == -1) {
        arr.push(data.companyId);
        // this.$refs.tree.setCheckedKeys(arr);
      } else if (!checked && arr.indexOf(data.companyId) != -1) {
        arr.splice(arr.indexOf(data.companyId), 1);
        this.getAllSystemListInfo();
      }
    },
    //鼠标移动tree按钮显示与消失
    mouseenter(data) {
      this.$set(data, "del", true);
    },
    mouseleave(data) {
      this.$set(data, "del", false);
    },
    // 删除拥有的系统
    async deleteInfo(data) {
      let params = {
        companyId: data.companyId,
        userId: this.$route.query.id,
      };
      const res = await cancelSpecialUserInfo(params);
      if (res.code === "200") {
        this.getAllSystemListInfo();
      } else {
        this.$message.error(res.msg);
      }
    },
    // 穿梭框选取的用户
    checkChangeUser(val, direction, movedKeys) {
      this.requestParams.defineAccessItemConfigurationDTOList.userCode = val;
    },
    // 选择的菜单
    checkButtonChange(data, checked, node) {
      this.selectMenuList = [
        ...checked.checkedKeys,
        ...checked.halfCheckedKeys,
      ];
    },
    //选择的部门
    checkGroupChange(data, checked, node) {
      this.groupParams.groupIds = checked.checkedKeys;
      this.requestParams.defineAccessItemConfigurationDTOList.groupId =
        checked.checkedKeys;
      this.$refs.tree3.setCheckedKeys(checked.checkedKeys);
    },
    // 自定义权限配置用户查询
    async getUserList() {
      this.groupParams.groupIds = this.groupParams.groupIds.toString();
      this.groupParams.companyId = this.companyIds;
      this.groupParams.userId = this.itemInfo.userId;
      const res = await findPageUserInfo(this.groupParams);
      if (res.code === "200") {
        if (
          res.data.list.pageQueryDataUserInfoDTOList &&
          res.data.list.pageQueryDataUserInfoDTOList.length > 0
        ) {
          res.data.list.pageQueryDataUserInfoDTOList.forEach((item) => {
            if (item.checkAuth) {
              this.selectUserList.push(item.userId);
            }
          });
          this.userList = res.data.list.pageQueryDataUserInfoDTOList;
        }
      } else {
        this.$message.error(res.msg);
      }
    },
    // 确认配置
    async confirmConfig() {
      let dataStatus = this.requestParams.defineAccessItemConfigurationDTOList
        .dataStatus;
      let groupIdString = this.requestParams
        .defineAccessItemConfigurationDTOList.groupId;
      if (dataStatus === 1 && groupIdString.length === 0) {
        this.$message.warning("请先选择部门");
        return;
      } else if (dataStatus === -1) {
        this.requestParams.defineAccessItemConfigurationDTOList.groupId = [];
        this.requestParams.defineAccessItemConfigurationDTOList.userCode = [];
      }
      let data = {
        companyId: this.companyIds,
        menuIds: Array.from(this.selectMenuList).toString(),
        userId: this.itemInfo.userId,
        defineAccessItemConfigurationDTOList: [
          {
            ...this.requestParams.defineAccessItemConfigurationDTOList,
            userCode: Array.from(this.selectUserList).toString(),
            groupId: this.requestParams.defineAccessItemConfigurationDTOList.groupId.toString(),
          },
        ],
      };
      const res = await defineAccessConfig(data);
      if (res.code === "200") {
        this.$message.success("修改成功");
      } else {
        this.$message.error(res.msg);
      }
    },
    // 继承权限配置
    async inheritanceUserInfo() {
      const res = await inheritPermission(this.itemInfo.userId);
      if (res.code === "200") {
        this.$message.success("修改成功");
        this.$router.back();
      } else {
        this.$message.error(res.msg);
      }
    },
    // 查询用户在某个系统下具有权限的菜单
    async getMenuList() {
      let params = {
        companyId: this.companyIds,
        userId: this.$route.query.id,
      };
      const res = await findMenuInfo(params);
      if (res.code === "200") {
        this.menuList = res.data.menuDTOList;
        this.$refs.tree1.setCheckedKeys(res.data.menuEntityList);
      } else {
        this.$message.error(res.msg);
      }
    },
    // 根据菜单ID查询按钮列表
    async getButtonList() {
      let params = {
        companyId: this.companyIds,
        menuId: this.selectMenuId,
        userId: this.$route.query.id,
      };
      const res = await findMenuList(params);
      if (res.code === "200") {
        this.buttonList = res.data.menuItemDTOList;
      } else {
        this.$message.error(res.msg);
      }
    },
    // 取消返回
    toBack() {
      this.$router.push("/sys/organizational");
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-transfer__buttons {
  padding: 0 14px;
}
::v-deep .el-button {
  padding: 10px;
}
.container-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.footer-btn {
  text-align: center;
  margin: 40px 0 10px;
}
</style>
